module.exports = __webpack_public_path__ + "static/media/checked-radio.50f89da1.svg";